<template>
    <ptk-teampoint bteam ></ptk-teampoint>
</template>

<script>
import PtkTeampoint from '@/components/PtkTeamPoint'

export default {
    name: 'PtkTest',
    components: {
        PtkTeampoint
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/PtkTest.vue